import { EntityApi } from "../../services/ApiPlatform";

export abstract class InternshipScheduleSkillApi extends EntityApi {
    protected static GET_COLLECTION = "/api/internship-schedule-skills";

    protected static POST_COLLECTION = "/api/internship-schedule-skills";

    protected static GET_ITEM = "/api/internship-schedule-skills/{id}";

    protected static PUT_ITEM = "/api/internship-schedule-skills/{id}";

    protected static PATCH_ITEM = "/api/internship-schedule-skills/{id}";

    protected static DELETE_ITEM = "/api/internship-schedule-skills/{id}";
}
